export const DOMAIN = 'https://api.osoulworld.com';

